import appLocaleData from 'react-intl/locale-data/ar';
import arMessages from '../locales/ar-AR';

const ArLang = {
    messages: {
        ...arMessages
    },
    locale: 'ar-AR',
    data: appLocaleData
};
export default ArLang;